import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md fade-up">
        <div className="mb-8"><Logo /></div>
        <h2 className="font-heading text-4xl font-black uppercase tracking-tight mb-2">New password</h2>
        <p className="text-muted-foreground mb-8">Choose a new password for your account.</p>
        {!token ? (
          <p className="text-sm font-semibold text-primary">Missing or invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-xs font-bold uppercase tracking-widest text-muted-foreground">New password</Label>
              <Input data-testid="reset-password-input" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" className="h-12 bg-card border-border" />
            </div>
            {error && <p className="text-sm font-semibold text-primary">{error}</p>}
            <Button type="submit" data-testid="reset-submit-button" disabled={loading}
              className="w-full h-12 bg-primary hover:bg-red-500 text-white font-heading font-bold uppercase tracking-widest transition-colors">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Reset password"}
            </Button>
          </form>
        )}
        <Link to="/login" className="inline-flex items-center gap-2 mt-8 text-sm font-bold text-white hover:text-primary transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
